import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import DHDefaultDrawer from "../../general/DHDefaultDrawer";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";

function StatisticManuellGameDialog({onClose, gameId}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [data, setData] = useState([]);
    const [datenGeladen, setDatenGeladen] = useState(false);

    useEffect(() => {
        ladeDaten();
    }, []);

    const ladeDaten = () =>  {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.game + "/statistik/manuell/" + gameId,
            json => {
                setData(json);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Statistikdaten: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Statistikdaten: " + error.message);
            })
    }

    const getRows = () => {

        let rows = [];
        if( data.length === 0)  {
            rows.push(<div style={{display:"flex", width:400, marginBottom:10}}>
                Keine Daten vorhanden...
            </div>)
        }
        for (const tmp of data) {
            rows.push(<div style={{display:"flex", width:400, marginBottom:10}}>
                <span style={{minWidth:200}}>{tmp.playerName}</span><span style={{minWidth:100}}>{tmp.typ}</span><span style={{minWidth:50}}>{tmp.value}</span>
            </div>)
        }
        return rows;
    }
    return <DHDefaultDrawer onClose={() => onClose()} title={"Statistik"} show={true} children={<div style={{padding:20}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div style={{marginBottom:30}}>
            Dieser Dialog zeigt dir im Doppelgame Statistikwerte zu den einzelnen Spielern.<br/>
            Die allgemeine Statistik unterscheidet nicht nach Einzelspielern sondern zeigt die Werte zur Doppelpaarung an.
        </div>
        {getRows()}
    </div>}/>
}

StatisticManuellGameDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    gameId: PropTypes.string.isRequired,
};

export default StatisticManuellGameDialog
